var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],attrs:{"id":_vm.indexedId}},[(_vm.shouldMount)?_vm._t("default",null,{"tabIndex":_vm.tabIndex}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }